import { render, staticRenderFns } from "./Devices.vue?vue&type=template&id=54864730&scoped=true"
import script from "./Devices.vue?vue&type=script&lang=js"
export * from "./Devices.vue?vue&type=script&lang=js"
import style0 from "./Devices.vue?vue&type=style&index=0&id=54864730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54864730",
  null
  
)

export default component.exports